// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"282":"3d1d9a61","340":"d91dd08e","453":"8b0a842d","523":"541d51f4","650":"2691bdd4","781":"656fff6e","999":"7346dfa2"}[chunkId] + ".chunk.js";
};